"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearDuplicateAlerts = exports.hasWarning = exports.hasError = void 0;

var _some = _interopRequireDefault(require("lodash/some"));

var _constants = require("../../skybase-core/notifications/constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @namespace skybase-components.sb-inline-messages.utils
 */

/**
 * @description
 * returns true if alert at least one alert in alerts is type of Error
 * @function
 *
 * @name skybase-components.sb-inline-messages.utils#hasError
 * @param  {Array.<skybase-components.sb-inline-messages.sb-inline-message#props>} alerts=Array()
 * @return {Boolean}
 */
var hasError = function hasError() {
  var alerts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return (0, _some.default)(alerts, function (alert) {
    return alert.type === _constants.ALERT_TYPE_ERROR || alert.severity === _constants.ALERT_TYPE_ERROR;
  });
};
/**
 * @description
 * returns true if alert at least one alert in alerts is type of Warning
 * @function
 *
 * @name skybase-components.sb-inline-messages.utils#hasWarning
 * @param  {Array.<skybase-components.sb-inline-messages.sb-inline-message#props>} alerts=Array()
 * @return {Boolean}
 */


exports.hasError = hasError;

var hasWarning = function hasWarning() {
  var alerts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return (0, _some.default)(alerts, function (alert) {
    return alert.type === _constants.ALERT_TYPE_WARNING || alert.severity === _constants.ALERT_TYPE_WARNING;
  });
};
/**
 * Remove duplicate notifications in case of multiple locations for one parameter
 * @param alerts
 * @returns {*}
 */


exports.hasWarning = hasWarning;

var clearDuplicateAlerts = function clearDuplicateAlerts(alerts) {
  return alerts.filter(function (filterAlert, index, arr) {
    return arr.map(function (alert) {
      return alert.type;
    }).indexOf(filterAlert.type) === index;
  });
};

exports.clearDuplicateAlerts = clearDuplicateAlerts;
//# sourceMappingURL=utils.js.map